module.exports = __webpack_public_path__ + "img/Vector.9cf8e760.svg";